"use client"

import Image from "next/image"
import { useEffect, useRef, useState } from "react"

type Logo = {
  src: string
  alt: string
  width: number
  height: number
}

const logos: Logo[] = [
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/bastion-logo.webp", alt: "Bastion", width: 180, height: 48 },
  { src: "/images/oceanic-health-logo.png", alt: "Oceanic Health", width: 180, height: 48, className: "h-14" },
  { src: "/images/delog-logo.png", alt: "Delog", width: 180, height: 48 },
  { src: "/images/NHLogo.png", alt: "Bastion", width: 180, height: 48 },
  
]

export function TrustedBySection() {
  const trackRef = useRef<HTMLDivElement>(null)
  const [shouldSlide, setShouldSlide] = useState(false)

  useEffect(() => {
    const many = logos.length >= 3  // Changed from 6 to 3 to enable carousel with current logos
    setShouldSlide(many)
    if (!many || !trackRef.current) return

    let frame = 0
    const el = trackRef.current
    let x = 0

    const step = () => {
      x -= 0.1  // Reduced from 0.2 to 0.1 for smoother animation with fewer logos
      el.style.transform = `translateX(${x}px)`
      if (Math.abs(x) > el.scrollWidth / 2) x = 0
      frame = requestAnimationFrame(step)
    }

    frame = requestAnimationFrame(step)
    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <section className="pt-[0.8rem] sm:pt-[1rem] pb-16 sm:pb-20 bg-white relative overflow-hidden">

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <h2 className="text-center text-[1.53rem] sm:text-[1.224rem] lg:text-[2.754rem] font-light text-gray-900 mb-8">
          Trusted by Tech-Forward Healthcare Organizations
        </h2>

        {/* Mobile/desktop: continuous marquee loop */}
        <div className="relative max-w-5xl mx-auto">
          <div className="rounded-2xl bg-white border border-gray-100 shadow-sm overflow-hidden">
            <div
              ref={trackRef}
              className="flex flex-nowrap items-center justify-start gap-10 sm:gap-14 md:gap-16 lg:gap-20 px-6 py-6 will-change-transform"
              aria-label="Trusted by logos"
            >
              {(shouldSlide ? [...logos, ...logos] : logos).map((logo, idx) => (
                <div
                  key={idx}
                  className="shrink-0 opacity-80 hover:opacity-100 transition-opacity duration-300 transform hover:scale-[1.03]"
                >
                  <Image
                    src={logo.src || "/placeholder.svg"}
                    alt={logo.alt}
                    width={logo.width}
                    height={logo.height}
                    className={`${logo.className || "h-10"} w-auto object-contain grayscale hover:grayscale-0`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .scrollbar-none::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-none {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  )
}
